import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React, { useState, useEffect } from 'react';
import { bool, func, string, shape } from 'prop-types';
import { Modal, ModalContent, Heading } from '@tesla/design-system-react';
import RegionTile from './RegionTile.js';
import { filterCountries, extractRegions } from './util.js';
import { TESLA_HEADER_API } from './constants.js';
import Styles from './RegionSelector.module.css.js';

var RegionSelector = function RegionSelector(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    selectedRegion = _ref.selectedRegion,
    onSelectRegion = _ref.onSelectRegion,
    t = _ref.t;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    regions = _useState2[0],
    setRegions = _useState2[1];
  useEffect(function () {
    if (open) {
      fetch(TESLA_HEADER_API).then(function (response) {
        return response.json();
      }).then(function (result) {
        if (result.localeSelector) {
          setRegions(filterCountries(extractRegions(result.localeSelector)));
        }
      });
    }
  }, [open]);
  return /*#__PURE__*/React.createElement(Modal, {
    backdrop: false,
    onClose: onClose,
    open: open,
    variant: "sheet-right",
    className: Styles['tw-react--region-selector--modal--dialog']
  }, /*#__PURE__*/React.createElement(ModalContent, {
    className: Styles['tw-react--region-selector--modal']
  }, regions ? regions.map(function (region) {
    var key = region.regionName;
    return /*#__PURE__*/React.createElement(RegionTile, _extends({}, region, {
      t: t,
      key: key,
      region: region,
      userLocale: {},
      selected: selectedRegion,
      onSelectRegion: onSelectRegion
    }));
  }) : /*#__PURE__*/React.createElement(Heading, null, "No Data")));
};
RegionSelector.defaultProps = {
  open: false,
  t: {},
  onClose: function onClose() {},
  userCountry: '',
  selectedRegion: '',
  onSelectRegion: function onSelectRegion() {}
};
RegionSelector.propTypes = {
  open: bool,
  onClose: func,
  selectedRegion: string,
  onSelectRegion: func,
  userCountry: string,
  t: shape({
    signout: string,
    allCountries: string,
    supportLink: string
  })
};

export { RegionSelector as default };
